const GoBackBtn = ({ steps, onChange }) => {
  let n = steps.len,
    ss = [...Array(n).keys()]

  const handleClick = (ix) => {
    if (onChange) onChange(ix)
    steps.goTo(ix)
  }

  return (
    <div className="dot-container">
      {ss.map((ix) => (
        <div
          key={ix}
          className={
            "dot" +
            (ix === steps.currentIx ? " active" : "") +
            (ix < steps.currentIx ? " enable" : "")
          }
          onClick={() => handleClick(ix)}
        ></div>
      ))}
      <div className={"dot" + (steps.done ? " active" : "")}></div>
    </div>
  )
}

export { GoBackBtn }
